export enum MenuItemAction {
	SHOW = 'show',
	SHOW_ALTERNATIVE = 'show_alternative',
	SHOW_INVOICE = 'show_invoice',
	STATUS = 'status',
	EDIT = 'edit',
	MOVE = 'move',
	DELETE = 'delete',
	REFRESH = 'refresh',
	DOWNLOAD = 'download',
	DUPLICATE = 'duplicate',
	SENT = 'sent',
	CANCEL = 'cancel',
	CREATE = 'create',
	CREATE_ALTERNATIVE = 'create_alternative',
	ARCHIVE = 'archive',
	PUBLISH = 'publish',
	RECTIFY = 'rectify',
	RESTORE = 'restore',
	ACTIVE = 'active',
	CONFIGURE = 'configure',
	BLOCK = 'block',
	ACCEPT = 'accept',
	REJECT = 'reject',
	DOWNLOAD_PDF = 'download_pdf',
	DOWNLOAD_JSON = 'download_json',
	IMPERSONATE = 'impersonate',
}

export enum Status {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	DEACTIVATE = 'deactivate',
	PENDING = 'pending',
	DELETED = 'deleted',
	ERROR = 'error',
	CREATED = 'created',
	ON_CONFIGURATION = 'on_configuration',
	READY = 'ready',
	DEACTIVE = 'deactive',
	DESACTIVE = 'desactive',
	IN_MAINTENANCE = 'in_maintenance',
	CLOSED = 'closed',
	PAUSED = 'paused',
	IN_PROGRESS = 'in_progress',
	COMPLETED = 'completed',
	CANCELLED = 'cancelled',
	IN_PROCESS = 'in_process',
	WAITING = 'waiting',
	OK = 'ok',
	KO = 'ko',
	READ = 'read',
	UNREAD = 'unread',
	CONSULTED = 'consulted',
	PROCESSED = 'processed',
	NO_PROCESSED = 'no_processed',
	ARCHIVED = 'archived',
	DRAFT = 'draft',
	APPEARED = 'appeared',
	OPEN = 'open',
	PENDING_INFO = 'pending_info',
	CLEARED = 'cleared',
	// Order / product statuses
	ANNULLED = 'annulled',
	ANNULLING = 'annulling',
	TERMINATED = 'terminated',
	TERMINATING = 'terminating',
	CANCELLING = 'cancelling',
	PROVISIONING = 'provisioning',
	PROVISIONED = 'provisioned',
	RESERVED = 'reserved',
	SUSPENDED = 'suspended',
	EXPIRED = 'expired',
	PENDING_SIM = 'pending_sim',
	PENDING_SIGNATURE = 'pending_signature',
	PENDING_SCORING_REVISION = 'pending_scoring_revision',
	/** Compra O2 hecha en funnel, pendiente de tramitar (CHF-784 / CHF-785). */
	PENDING_PROCESSING = 'pending_processing',
	SCORING_REJECTED = 'scoring_rejected',
	PACKAGE_IN_ERROR = 'package_in_error',
}

export enum Priority {
	LOWEST = 'lowest',
	LOW = 'low',
	MEDIUM = 'medium',
	HIGH = 'high',
	HIGHEST = 'highest',
}


export enum AddressType {
	BILLING = 1,
	INSTALLATION = 2,
	SIM_DELIVERY = 3,
}

export interface IResourceResponse<T> {
	data?: T;
}

export interface IPaginationResponse {
	current_page?: number;
	from?: number;
	last_page?: number;
	per_page?: number;
	to?: number;
	total?: number;
	request_id?: string;
	page?: number;
	path?: string;
	links?: IPaginationMetaLink[];
}

export interface IPaginationMetaLink {
	url?: string;
	label?: string;
	page?: number | null;
	active?: boolean;
}

export interface IPaginationLinks {
	first?: string;
	last?: string;
	prev?: string | null;
	next?: string | null;
}

export interface IMetaResponse {
	request_id?: string;
}

export interface IStatus {
	name?: string;
	label?: string;
}

export interface IFile {
	uuid?: string;
	filename?: string;
	link?: string;
	mime_type?: string;
	size?: any;
	data?: any;
}
